var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ra-card"},[(_vm.header)?_c('div',{staticClass:"ra-card--heading"},[_vm._t("header")],2):_vm._e(),_vm._t("content")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }